<template>
    <div class='bxKbdjs' v-if='kbxmlc'>
        <div class='box'>
            <!-- <h2>距离<span>{{endTime}}</span>开标倒计时</h2> -->
            <h2>开标倒计时</h2>
            <myClock :shenyu='shenyu' v-if='shenyu' cId='c1'></myClock>
            <el-button type="primary" v-if="role == 'Z'" @click='bxNextBtn' :disabled="kbxmlc.zt==2 || !isNext">进入开标</el-button>
        </div>
    </div>
    <div v-else class='loading'>
        <p>页面正在加载中...</p>
        <div id="colorfulPulse">
            <span class='item-1'></span>
            <span class='item-2'></span>
            <span class='item-3'></span>
            <span class='item-4'></span>
            <span class='item-5'></span>
            <span class='item-6'></span>
            <span class='item-7'></span>
        </div>
    </div>
</template>
<script>
import myClock from '../../components/clock/clock'
export default {
    name:'bxKbdjs',
    components:{
        myClock
    },
    computed:{
        isNext() {
            return this.kbsj <= new Date().getTime()
        },
        role() {
            return localStorage.getItem('role')?localStorage.getItem('role'):'T'
        }
    },
    data(){
        return{
            waitLoading:false,
            djlcId:'',//节点流程id
            kbxmlc:'',
            endTime:'',//开标时间
            shenyu:'',
            shenyuTime:'',
            intervalQd:'',//定时器
            isBegin:false,//是否已开启签到
            isOver:false,//签到时间是否截止
            qddws:0,//已签到单位数
            qddwList:[],//已签到单位列表
            tbdwmc:'',//查询签到单位
            msg:null,
            text:'',
            kbsj:'' // 用于判断是否可以点下一步
        }
    },
    methods: {
        getData(){
            let para={
                djlcId:this.djlcId,
            }
            this.waitLoading=true
            this.$api.kbqdList(para).then(res=>{
                if(res.data.meta.success){
                    this.kbxmlc=res.data.data.kbxmlc
                    var time=new Date(res.data.data.kbsj);
                    this.kbsj = new Date(time).getTime()
                    var h=time.getHours()>=10?time.getHours():'0'+time.getHours();
                    var m=time.getMinutes()>=10?time.getMinutes():'0'+time.getMinutes();
                    var s=time.getSeconds()>=10?time.getSeconds():'0'+time.getSeconds();
                    this.shenyu=res.data.data.djs;
                    if(this.shenyu > 0){
                        this.isKb()
                    }
                    this.endTime=h+":"+m+":"+s;
                }else{
                    this.$message({
                        type:'error',
                        message:res.data.meta.message
                    })
                }
                this.waitLoading=false
            }).catch(()=>{})
        },
        searchTbdw(){
            this.currentPage=1;
        },
        bxNextBtn(){
            let para={
                flag:this.kbxmlc.ycdz
            }
            this.waitLoading=true
            this.$emit('bxNextBtn',para)
        },
        isKb() {
            var _this=this;
            clearInterval(_this.intervalKb);
            _this.intervalKb=null;
            this.intervalKb=setInterval(function(){
                if (_this.shenyu < 1000) {
                    clearInterval(_this.intervalKb);
                    _this.intervalKb=null;
                    _this.getData()
                    return;
                }
                _this.shenyu=_this.shenyu-1000;
            },1000)
        },
        //计算剩余时间倒计时
        qdshenyuFun(){
            var _this=this;
            clearInterval(_this.intervalQd);
            _this.intervalQd=null;
            this.intervalQd=setInterval(function(){
                if(_this.shenyu<1000){
                    _this.shenyuTime='00:00:00'
                    _this.isOver=true;
                    clearInterval(_this.intervalQd);
                    _this.intervalQd=null;
                    return;
                }
                var shengyuD=parseInt(_this.shenyu/(60*60*24*1000));//转换为天
                var D=parseInt(_this.shenyu)-parseInt(shengyuD*60*60*24*1000);//除去天的毫秒数
                var shengyuH=parseInt(D/(60*60*1000));//除去天的毫秒数转换成小时
                var H=D-shengyuH*60*60*1000;//除去天、小时的毫秒数
                var shengyuM=parseInt(H/(60*1000));//除去天的毫秒数转换成分钟
                var M=H-shengyuM*60*1000;//除去天、小时、分的毫秒数
                var S=parseInt((_this.shenyu-shengyuD*60*60*24*1000-shengyuH*60*60*1000-shengyuM*60*1000)/1000);//除去天、小时、分的毫秒数转化为秒
                var ss = String(S);
                var mm = String(shengyuM);
                var hh = String(shengyuH);
                if (ss.length==1) ss = "0"+ss;
                if (mm.length==1) mm = "0"+mm;
                if (hh.length==1) hh = "0"+hh;
                _this.shenyuTime=hh+':'+mm+':'+ss
                _this.shenyu=_this.shenyu-1000;
                if(_this.role=="Z"){
                    if(_this.shenyuTime=="00:10:00"){
                        _this.text='距离开标仅剩10分钟';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:05:00"){
                        _this.text='距离开标仅剩5分钟';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:01:00"){
                        _this.text='距离开标仅剩1分钟';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:00:05"){
                        _this.text='5';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:00:04"){
                        _this.text='4';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:00:03"){
                        _this.text='3';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:00:02"){
                        _this.text='2';
                        _this.handleSpeak();
                    }else if(_this.shenyuTime=="00:00:01"){
                        _this.text='1，签到结束，开始开标。';
                        _this.handleSpeak();
                    }
                }
            },1000)
        },   
        qdsjFormatter(row, column, cellValue, index){
            if (row.qdsj) {
                return this.$moment(row.qdsj).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        handleSpeak(){
            var msg = new SpeechSynthesisUtterance();
            speechSynthesis.cancel(msg);
            msg.text = this.text;//文本
            msg.lang = 'EN';
            msg.volume = 1;//声音的音量，区间范围是0到1，默认是1
            msg.rate = 1;//语速
            msg.pitch = 1;//音调高低
            speechSynthesis.speak(msg);
        },
        
    },
    mounted(){
        this.djlcId=this.$route.query.djlcId;
        this.getData();
    },
    beforeDestroy(){
        // clearInterval(this.intervalQd);
        // this.intervalQd=null;
        clearInterval(this.intervalKb);
        this.intervalKb=null;
    }
}
</script>
<style lang="less" scope>
    div.bxKbdjs>.box{
        background:white;
        border-color:white;
        border-top:2px solid white;
        height:100%;
        text-align: center;
        padding-top:80px;
        h2{
            font-size: 36px;
        }
        .el-button{
            width:350px;
            height:55px;
            line-height:55px;
            font-size: 20px;
        }
    }
    .qdTime{
        height:150px;
        background:#fdf0f3;
        border:1px solid @border-color;
        border-top:2px solid @base-color;
        padding:0 60px;
        margin-bottom:10px;
        >div{
            font-size: 20px;
            color:#333;
            line-height:139px;
            float:left;
            width:50%;
            >span{
                color:@base-color;
                font-size:48px;
                font-weight: bold;
                margin-left:10px;
            }
        }
    }
    .qdContent{
        background:@base-Bg;
        border:1px solid #ddd;
        padding:55px 50px;
        .qdOver{
            height: 350px;
            line-height: 350px;
            color:@base-color;
            font-size: 48px;
            text-align: center;
        }
    }
    .zbBox.noBtn{
        border:1px solid #ddd;
        background:@base-Bg;
        padding:10px;
    }
    .qdContent.noBtn,.zbBox.noBtn{
        height:calc(~"100% - 160px");
    }
    .lookQddw{
        border:1px solid #ddd;
        background:#fff;
        padding:0 10px;
        line-height:45px;
        height:45px;
        .el-button--text{
            color:@warning-color;
        }
        .el-button--text:hover, .el-button--text:focus{
            color:fade(@warning-color,80%)
        }
        p{
            span{
                color:@base-color;
                margin:0 5px;
            }
        }
    }
    .bxKbdjs .errorMsg{
        height: 30px;
        margin-left:70px;
        p{
            background:url('../../assets/images/error.jpg') no-repeat 10px center;
            color:@base-color;
            font-size: 12px;
            padding-left:30px;
        }
    }
   .el-input-group__append button.el-button{
       min-width:40px;
   }
</style>
